import { GuaranteeApiDatasource } from '../data/datasources/guarantee-api.datasource';
import { GuaranteeRepositoryImpl } from '../data/repositories/guarantee.repository.impl';

const api = new GuaranteeApiDatasource();
const repository = new GuaranteeRepositoryImpl(api);

export const guaranteeContainer = { repository };
